import { Chip } from '@rneui/base/dist/Chip/Chip';
import { withTheme } from '../config';
export { Chip };
export default withTheme(Chip, 'Chip');
